import {
    COLLECTION_ARTICLES_SUCCESS,
    COLLECTION_ARTICLES_ADD,
    COLLECTION_ARTICLES_FAILURE,
} from '../actions/types';

const defaultCollectionArticlesState = () => ({
    collection: [],
    meta: {},
    clientPlacedAds: [],
    error: false,
});

/* eslint-disable import/prefer-default-export */
export const fetchCollectionArticlesReducer = (
    state = defaultCollectionArticlesState(),
    action,
) => {
    if (action.type === COLLECTION_ARTICLES_SUCCESS) {
        const { payload } = action;

        return {
            ...state,
            collection: payload.articles.filter((article) => !article.error),
            meta: payload.meta,
            clientPlacedAds: payload.clientPlacedAds,
        };
    }

    if (action.type === COLLECTION_ARTICLES_ADD) {
        return {
            ...state,
            collection: [...state.collection].concat([
                ...action.payload.articles.filter((article) => !article.error),
            ]),
        };
    }

    if (action.type === COLLECTION_ARTICLES_FAILURE) {
        return {
            ...state,
            ...action.payload,
            error: true,
        };
    }

    return state;
};
/* eslint-enable import/prefer-default-export */



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/collection-articles.js
 **/